export const soundmap = {
  "1": [1203, 192],
  "2": [10794, 197],
  "3": [11315, 196],
  "4": [11814, 198],
  "5": [12334, 185],
  "6": [12845, 196],
  "7": [13305, 188],
  "8": [13846, 187],
  "9": [14362, 197],
  "10": [14881, 188],
  "11": [15408, 180],
  "12": [15901, 200],
  "13": [16410, 182],
  "14": [16906, 230],
  "15": [19473, 191],
  "16": [19944, 207],
  "17": [20490, 183],
  "18": [20995, 192],
  "19": [21500, 186],
  "20": [21993, 198],
  "21": [22495, 185],
  "22": [22970, 194],
  "23": [23492, 179],
  "24": [23972, 212],
  "25": [24468, 181],
  "26": [24955, 187],
  "27": [25463, 172],
  "28": [34274, 204],
  "29": [42603, 172],
  "30": [28961, 164],
  "31": [29448, 171],
  "32": [29968, 163],
  "33": [30454, 208],
  "34": [30944, 172],
  "35": [31395, 186],
  "36": [31884, 174],
  "37": [32358, 172],
  "38": [32358, 172],
  "39": [33331, 191],
  "40": [33824, 166],
  "41": [10318, 183],
  "42": [35598, 197],
  "43": [25952, 184],
  "44": [36143, 204],
  "45": [36645, 165],
  "46": [37120, 164],
  "47": [37606, 181],
  "48": [38062, 179],
  "49": [38563, 163],
  "50": [39025, 171],
  "51": [39505, 172],
  "52": [39982, 152],
  "53": [40437, 170],
  "54": [40939, 176],
  "55": [9180, 193],
  "56": [43991, 192],
  "57": [49628, 230],
  "58": [28470, 191],
  "59": [1783, 185],
  "60": [2336, 204],
  "61": [2884, 182],
  "62": [3404, 188],
  "63": [3940, 168],
  "64": [4487, 165],
  "65": [5013, 178],
  "66": [5510, 187],
  "67": [6048, 207],
  "68": [6609, 174],
  "69": [8159, 221],
  "70": [8668, 222],
  "71": [17483, 175],
  "72": [17955, 189],
  "73": [18419, 199],
  "74": [15901, 200],
  "75": [26567, 177],
  "76": [27069, 190],
  "77": [27541, 169],
  "78": [16906, 230],
  "79": [47492, 178],
  "80": [47981, 201],
  "81": [48412, 201],
  "82": [40939, 176],
  "83": [41501, 174],
  "87": [7119, 175],
  "88": [7650, 174],
  "3612": [34274, 204],
  "3613": [47002, 188],
  "3637": [8668, 222],
  "3639": [8159, 221],
  "3640": [46069, 202],
  "3653": [9180, 193],
  "3655": [17955, 189],
  "3657": [18419, 199],
  "3663": [27069, 190],
  "3665": [27541, 169],
  "3666": [17483, 175],
  "3667": [26567, 177],
  "3675": [43435, 155],
  "3676": [46544, 174],
  "3677": [47002, 188],
  "57416": [41501, 174],
  "57419": [47492, 178],
  "57421": [48412, 201],
  "57424": [47981, 201],
  "60999": [17955, 189],
  "61000": [41501, 174],
  "61001": [18419, 199],
  "61003": [47492, 178],
  "61005": [48412, 201],
  "61007": [27069, 190],
  "61008": [47981, 201],
  "61009": [27541, 169],
  "61010": [17483, 175],
  "61011": [26567, 177],
};
